(function () {
  'use strict';

  // Island purchase CTAs link to the kit section (#box) in the template, never to a cart URL.
  // A tap before this script binds, with the script blocked, or in a new tab only scrolls to the kit,
  // so no path can reach a shake-only checkout.
  var CTA_SELECTOR = 'a[href="#box"], button[data-href="#box"]';
  var STOCK_MESSAGE = 'Part of the Island Kit is out of stock right now. Check back soon.';
  var RETRY_MESSAGE = 'We could not add the full kit right now. Please refresh the page and try again.';
  var OTHER_KIT_MESSAGE = 'Your cart already has a free welcome kit. Our offers include one free kit per order.';

  function init() {
    try {
      var configElement = document.querySelector('[data-island-kit-config]');
      if (!configElement) return;
      var config = JSON.parse(configElement.textContent);
      var ctas = document.querySelectorAll(CTA_SELECTOR);
      var busy = false;

      function setBusy() {
        Array.prototype.forEach.call(ctas, function (cta) {
          cta.setAttribute('aria-busy', 'true');
          cta.classList.add('is-loading');
          cta.textContent = 'Adding kit…';
        });
      }

      // Back/forward cache can restore the page mid-"Adding kit…" after a trip to checkout.
      function resetBusy() {
        busy = false;
        Array.prototype.forEach.call(ctas, function (cta) {
          if (!cta.classList.contains('is-loading')) return;
          cta.removeAttribute('aria-busy');
          cta.classList.remove('is-loading');
          cta.textContent = cta.getAttribute('data-island-kit-label');
        });
      }

      // Never fall back to a shake-only purchase: the page promises the whole kit.
      function markUnavailable(cta, message, label) {
        cta.setAttribute('aria-disabled', 'true');
        cta.removeAttribute('aria-busy');
        cta.classList.remove('is-loading');
        cta.classList.add('is-unavailable');
        cta.textContent = label || 'Kit temporarily unavailable';
        var next = cta.nextElementSibling;
        if (next && next.hasAttribute('data-island-kit-notice')) {
          next.textContent = message;
          return;
        }
        var notice = document.createElement('p');
        notice.className = 'lp-micro';
        notice.setAttribute('data-island-kit-notice', '');
        notice.textContent = message;
        cta.insertAdjacentElement('afterend', notice);
      }

      async function purchase() {
        try {
          setBusy();
          var response = await fetch('/cart.js', {
            headers: { 'Accept': 'application/json' },
            credentials: 'same-origin'
          });
          if (!response.ok) throw new Error('Island Kit cart lookup failed');
          var cart = await response.json();
          var cartItems = cart.items || [];
          // One free kit per cart: a welcome kit already in the cart blocks the Island Kit.
          var welcomeIds = (config.welcomeKitIds || []).map(String);
          var hasWelcomeKit = cartItems.some(function (line) {
            return line.properties && line.properties._promo_free_gift &&
              welcomeIds.indexOf(String(line.variant_id)) !== -1;
          });
          if (hasWelcomeKit) {
            var kitError = new Error('Cart already holds a free welcome kit');
            kitError.otherKit = true;
            throw kitError;
          }
          var items = [];
          var hasShake = cartItems.some(function (line) {
            if (String(line.variant_id) !== String(config.qualifyingVariantId)) return false;
            var allocation = line.selling_plan_allocation;
            return config.mode === 'sub'
              ? allocation && allocation.selling_plan &&
                String(allocation.selling_plan.id) === String(config.sellingPlanId)
              : !allocation;
          });
          if (!hasShake) {
            var shake = { id: config.qualifyingVariantId, quantity: 1 };
            if (config.mode === 'sub') shake.selling_plan = config.sellingPlanId;
            items.push(shake);
          }
          config.gifts.forEach(function (gift) {
            var exists = cartItems.some(function (line) { return String(line.variant_id) === String(gift.id); });
            if (!exists) items.push({ id: gift.id, quantity: 1, properties: { _island_kit_gift: 'true' } });
          });
          // A complete cart needs no mutation. Gifts are always one-time lines.
          if (items.length) {
            var added = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ items: items })
            });
            if (!added.ok) {
              var failure = new Error('Island Kit add failed');
              failure.stock = added.status === 422;
              throw failure;
            }
          }
          window.location.href = '/checkout';
        } catch (error) {
          // A shake-only checkout would silently drop the promised kit, so stay on the page instead.
          console.warn('Island Kit could not be added.', error);
          if (error && error.otherKit) {
            Array.prototype.forEach.call(ctas, function (cta) {
              markUnavailable(cta, OTHER_KIT_MESSAGE, 'One free kit per order');
            });
            return;
          }
          var message = error && error.stock ? STOCK_MESSAGE : RETRY_MESSAGE;
          Array.prototype.forEach.call(ctas, function (cta) { markUnavailable(cta, message); });
        }
        // The busy lock stays on: the shopper either leaves for checkout or sees the unavailable state.
      }

      Array.prototype.forEach.call(ctas, function (cta) {
        cta.setAttribute('data-island-kit-cta', '');
        cta.setAttribute('data-island-kit-label', cta.textContent);
        if (config.allAvailable !== true) markUnavailable(cta, STOCK_MESSAGE);
        cta.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (config.allAvailable !== true || busy) return;
          busy = true;
          purchase();
        }, true);
      });

      window.addEventListener('pageshow', function (event) {
        if (event.persisted) resetBusy();
      });
    } catch (error) {
      // The CTAs stay plain #box anchors, so a broken setup can only scroll, never sell the shake alone.
      console.warn('Island Kit could not initialize.', error);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
